export const expertStepCn = {
    zhuanjiatouxiang:"专家头像：",
    shangchuantouxiang:"上传头像",
    zhuanjiamingcheng:"专家名称：",
    xiangguanxinxi:"请输入相关信息",
    zhuanjiafenglei:"专家分类：",
    suozaidizhi:"专家所在地址：",
    zhuanjiashanchang:"专家擅长行业(可多选)：",
    xzschy:"请选择擅长行业",
    lianxifangshi:"联系方式：",
    zjscqy:"专家擅长区域(可多选)：",
    xzrzfwgj:"请选择检测认证服务国家",
    zjzl:"专家资历：",
    zjjj:"专家简介：",
    zjsfz:"上传专家身份证扫描件：",
    sfzzmsc:"身份证正面上传",
    sfzfmsc:"身份证反面上传",
    sczjzzzs:"上传专家资质证书扫描件（可选上传多份）：",
    sczjgrlw:"上传专家个人论文：",
    jygzjl:"教育工作经历：",
    xieyi:"《贸促通产品检测认证平台协议》"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertStep/indexCn.js